import React, { lazy, Suspense } from 'react';

const LazyPrintMaterialOrderForm = lazy(() => import('./PrintMaterialOrderForm'));

const PrintMaterialOrderForm = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyPrintMaterialOrderForm {...props} />
  </Suspense>
);

export default PrintMaterialOrderForm;
